import ComingSoon from "@/components/common/ComingSoon";
export default function PartnerApplication() {
  return <ComingSoon phaseKey="phase5" testId="page-partner-application" />;
}
